import { UserRegiserMixpanel } from "@type/auth";
import mixpanel from "mixpanel-browser";

export const setUserRegister = (currentUser: UserRegiserMixpanel) => {
    if (import.meta.env.VITE_APP_ENV === "production") {
        mixpanel.identify(currentUser.user_id);
        mixpanel.people.set({
            $name: currentUser.name || "",
            $email: currentUser.email,
            $role: currentUser.role || "",
        });
    } else {
        console.log("Mixpanel identify:", currentUser);
    }
};


export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
    if (import.meta.env.VITE_APP_ENV === "production") {
        mixpanel.track(eventName, properties);
    } else {
        console.log("Mixpanel event tracked:", eventName, properties);
    }
};